import { createSlice } from '@reduxjs/toolkit';

let sidebarShow = window.localStorage.sidebarShow;
if (!sidebarShow || sidebarShow === 'true') {
	sidebarShow = true;
} else {
	sidebarShow = false;
}

const initialState = {
	sidebarShow,
	activeMenuItem: null, // Путь активного пункта меню (например, '/publications/consultations')
};

const sidebarSlice = createSlice({
	name: 'sidebar',
	initialState,
	reducers: {
		toggleSidebar: (state, action) => {
			window.localStorage.setItem('sidebarShow', action.payload);
			state.sidebarShow = action.payload;
		},
		setActiveMenuItem: (state, action) => {
			state.activeMenuItem = action.payload;
		},
	},
});

export const { toggleSidebar, setActiveMenuItem } = sidebarSlice.actions;

export default sidebarSlice.reducer;
